module.exports = __webpack_public_path__ + "img/cb4.6e1563a4.jpg";